export default "__VITE_ASSET__Co81c9k2__"